import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../base-component';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { ResInstructionsGridDTO } from 'src/app/core/Dtos/res/instructions-grid-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { ResService } from 'src/app/core/services/res.service';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';

@Component({
  selector: 'app-res-dashboard',
  templateUrl: './res-dashboard.component.html',
  styleUrl: './res-dashboard.component.scss',
  standalone: false
})
export class ResDashboardComponent extends BaseComponent {
  @Output()
  public OnViewInstruction: EventEmitter<TraderInstructionArgs> = new EventEmitter<TraderInstructionArgs>();

  public SearchCurrentAndFuture: string = "ShowActiveAndFutrure";
  public SearchDateFrom: Date = new Date();
  public SearchDateTo: Date = new Date();

  public ResIntructionsData: ResInstructionsGridDTO[] = [];
  public ResAdHocData: AdHocInstructionsGridDTO[] = [];
  public ResLastRefresh: string = "";

  public Asset: Assets;
  private _addNewRoute: string = "";

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _router: Router,
    private _resService: ResService,
    private _adHocService: AdHocInstructionsService) {
    super(oktaService, alertService, dateFormatHelper);
    // Load Instructions
    this.Asset = Assets.Res;
    this.SearchDateFrom.setMonth(this.SearchDateFrom.getMonth() - 1);



    this.GetInstructions();
  }

  public GetInstructions() {
    if (this.SearchCurrentAndFuture == "ShowActiveAndFutrure") {
      this._resService.GetActiveAndFutureInstructions().subscribe(
        resp => {
          this.ResIntructionsData = resp;
          this.ResLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetActiveAndFutureInstructions(Assets.Res).subscribe(
        resp => {
          this.ResAdHocData = resp;
        }
      );
    }
    else {
      this._resService.GetInstructionsByDateRange(this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.ResIntructionsData = resp;
          this.ResLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetInstructionsByDateRange(Assets.Res, this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.ResAdHocData = resp;
        }
      );
    }
  }

  public SetDateTo(target: any) {
    this.SearchDateTo = target.valueAsDate;
  }
  public SetDateFrom(target: any) {
    this.SearchDateFrom = target.valueAsDate;
  }

  public AddNewInstruction() {
    this._router.navigate(["res-new"]);
  }

  public AddNewAdHocInstruction() {
    this._router.navigate(["res/adhoc-new"]);
  }

  public ViewInstruction(instructionId: string | number, isAdHoc: boolean) {
    this.OnViewInstruction?.next(new TraderInstructionArgs(Assets.Res, instructionId, isAdHoc));
  }
  public CopyToNew(instructionId: string | number) {
    let viewingRoute = `res-new/${instructionId}`;
    this._router.navigate([viewingRoute]);
  }
}
